// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"be1fc0b7","339":"4017b75c","356":"8ef01e70","436":"80008226","655":"b3447451"}[chunkId] + ".chunk.js";
};